// Code generated by scripts/gen-sdk-contenttypes from internal/contenttype; DO NOT EDIT.
// Run `task contenttypes:sync` to regenerate. CI gates this file (git diff --exit-code).
//
// ALWAYS_DENIED mirrors the data plane's script-bearing deny-list (dropping
// an entry on both sides is a same-origin script-injection hole); COMPRESSIBLE
// is the set the SDK may gzip before upload. Both are single-sourced in Go.

export const ALWAYS_DENIED: ReadonlySet<string> = new Set([
  "text/html",
  "application/xhtml+xml",
  "application/javascript",
  "text/javascript",
  "application/ecmascript",
  "text/ecmascript",
  "image/svg+xml",
]);

export const COMPRESSIBLE: ReadonlySet<string> = new Set([
  "text/plain",
  "text/css",
  "text/csv",
  "text/markdown",
  "application/json",
]);
